import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import classNames from "classnames";
import { DatePickerComponent } from "Component/Custom";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import LabelIcon from "Component/Labels/LabelIcon";
import SearchSq from "Component/Material-ui/SearchSq";
import headersList from "Constants/headersList";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import AddScreeningQuestion from "Module/Subscription/ConfigMode/Recruit/ScreeningQuestions/AddScreeningQuestion";
import { withSnackbar } from "notistack";
import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { getEJ2CalenderDateFormat } from "Utils";

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

const jobstype = [
  {
    displayvalue: 1,
    displayname: "New hire",
  },
  {
    displayvalue: 2,
    displayname: "Replacement",
  },
];

const questioncategories = [
  {
    displayname: "Company and culture questions",
    displayvalue: 1,
  },
  {
    displayname: "New",
    displayvalue: 2,
  },
];

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      flag: false,
      requisitionTitle: "",
      description: "",
      jobs: [],
      jobTypeId: "",
      positionCount: "",
      hiredate: "",
      locations: [],
      locationId: "",
      employmentTypeId: "",
      employmenttypes: [],
      employeeId: "",
      employees: [],
      priorityId: "",
      hiringPlanId: "",
      hiringPlans: [],
      priorities: [
        { displayvalue: "1", displayname: "Immediate" },
        { displayvalue: "2", displayname: "Moderate" },
        { displayvalue: "3", displayname: "Relaxed" },
      ],
      allemployees: [],
      requistionsList: [],
      createmenu: false,
      create_anchorEl: null,
      headers: [
        {
          key: "requisitionname",
          name: "Requisition name",
          style: { textAlign: "left" },
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
        },
        {
          key: "numberofjobs",
          name: "Number of jobs",
          style: { textAlign: "left" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "addedbyimagepath",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "hiringplan",
          name: "Hiring plan",
          style: { textAlign: "left" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "moreoptions",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
      addjobs: false,
      questioncategoryid: null,

      answertypeid: 0,
      idx: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.setInputType = this.setInputType.bind(this);
  }

  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  setInputType(answertypeid) {
    this.setState({
      answertypeid,
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  SelectHireDate(args) {
    const date = this.ConvertDate(args.value);
    const hiredate = date;
    this.setState({ hiredate });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { classes } = this.props;
    const { addjobs } = this.state;
    return (
      <div className="content-outer-wrapper-with-tab">
        {this.state.flag ? (
          <div>
            <Helmet>
              <title>{headersList.Recruit.Requisition.header}</title>
            </Helmet>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <PageHeader header="Create new requisition" />
                <p className="normal-dark-secondary margin-bottom-8">
                  Easily create requisitions for jobs and assign them to a
                  hiring plan. 👩‍💼
                </p>
                <div style={{ width: 350 }}>
                  <DynamicForm
                    fields={textinputconverter({
                      value: this.state.requisitionTitle,
                      label: "Title of requisition",
                      placeholder: "Enter title",
                    })}
                    onChange={(e) => this.handleChange("requisitionTitle", e)}
                  />

                  <DynamicForm
                    fields={textareainputconverter({
                      value: this.state.description,
                      label: "Requisition description",
                      placeholder: "Enter title",
                    })}
                    onChange={(e) => this.handleChange("description", e)}
                  />
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.hiringPlanId,
                      placeholder: "",
                      label: "Which hiring plan should this be added to?",
                      options: this.state.hiringPlans,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("hiringPlanId", selectedid);
                    }}
                  />
                </div>

                <p className="normal-dark-secondary margin-bottom-16">
                  Job list
                </p>
                <div
                  className="rounded-rectangle-div margin-bottom-16"
                  style={{ width: 330 }}
                >
                  <span className="floatleft">
                    <LabelIcon label="Head count stats" img={designationIcon} />
                    <LabelIcon label="employee namee" img={designationIcon} />
                  </span>
                  <span className="floatright">
                    <img src={deleteIcon}></img>
                    <p className="extra-small-dark-secondary">3 positions</p>
                  </span>
                  <div className="clear-float"></div>
                </div>
                <div>
                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    onClick={() =>
                      this.setState({ drawerOpen: true, addjobs: true })
                    }
                  >
                    Add job
                  </Button>
                </div>
                <Button
                  className="btn btn-primary-md-blue margin-top-16"
                  variant="contained"
                  onClick={() =>
                    this.setState({ drawerOpen: true, addjobs: false })
                  }
                >
                  Add screening question
                </Button>
              </Grid>
            </Grid>
            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  drawerOpen: false,
                  addjobs: false,
                })
              }
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              <DrawerHeader
                header={addjobs ? "Add job" : "Add screening questions"}
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    drawerOpen: false,
                    addjobs: false,
                  })
                }
              />
              {addjobs ? (
                <div>
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.jobId,
                      placeholder: "Select job",
                      label: "Job",
                      options: this.state.jobs,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("jobId", selectedid);
                    }}
                  />
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.jobTypeId,
                      placeholder: "Select",
                      label: "New hire or replacement?",
                      options: jobstype,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("jobTypeId", selectedid);
                    }}
                  />
                  {this.state.jobTypeId == 1 && (
                    <div>
                      <DynamicForm
                        fields={integerinputconverter({
                          value: this.state.positionCount,
                          placeholder: "Enter number of positions",
                          label: "How many positions are available?",
                          min: 1,
                        })}
                        onChange={(value) => {
                          this.handleChange(value, "positionCount");
                        }}
                      />
                    </div>
                  )}
                  {this.state.jobTypeId == 2 && (
                    <div>
                      <DynamicForm
                        fields={multiselectinputconverter({
                          value: this.state.employeeids,
                          label: "Outgoing employee(s)",
                          placeholder: "Select employee(s)",
                          options: this.state.allemployees,
                        })}
                        onChange={(ids) => {
                          this.handleChange("employeeids", ids);
                        }}
                      />
                      <p className="extra-small-dark-secondary">
                        3 positions will be shown as available
                      </p>
                    </div>
                  )}

                  <div>
                    <p className="input-label">Hire by date</p>
                    <DatePickerComponent
                      placeholder="Select Date"
                      id="startDate"
                      allowEdit
                      format={getEJ2CalenderDateFormat()}
                      value={this.state.hiredate}
                      min={this.state.minApplyDate}
                      change={this.SelectHireDate.bind(this)}
                    />
                  </div>
                  <div className="margin-top-16">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: this.state.locationId,
                        placeholder: "Select location",
                        label: "Reporting location",
                        options: this.state.locations,
                      })}
                      onChange={(selectedid) => {
                        this.handleChange("locationId", selectedid);
                      }}
                    />
                  </div>
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.employmentTypeId,
                      placeholder: "Select type",
                      label: "Employment type",
                      options: this.state.employmenttypes,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("employmentTypeId", selectedid);
                    }}
                  />

                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.priorityId,
                      placeholder: "Select priority",
                      label: "Job priority",
                      options: this.state.priorities,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("priorityId", selectedid);
                    }}
                  />

                  <Button
                    className="btn btn-primary-md-blue"
                    variant="contained"
                    onClick={() =>
                      this.setState({ drawerOpen: false, addjobs: false })
                    }
                  >
                    Add job
                  </Button>
                </div>
              ) : (
                <AddScreeningQuestion />
              )}
            </Drawer>
          </div>
        ) : (
          <div>
            {this.state.requistionsList.length == 0 ? (
              <div>
                <Grid container className="margin-bottom-24" spacing={3}>
                  <Grid item md={10} sm={2}>
                    <SearchSq
                      placeholder="Search"
                      value={this.state.searchValue}
                      onChange={this.handleSearch}
                    />
                  </Grid>
                  <Grid item md={2} sm={2}>
                    <div>
                      {this.state.permissions.editable && (
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue width100"
                          color="primary"
                          onClick={() => this.setState({ flag: true })}
                        >
                          Create new
                        </Button>
                      )}
                    </div>
                  </Grid>
                </Grid>
                <List
                  showOnlyList
                  list={this.state.requistionsList}
                  permissions={this.state.permissions}
                  headers={this.state.headers}
                  onEdit={this.onEdit}
                  onPreview={this.onPreview}
                  onDelete={this.onDelete}
                  onStateStatusChange={this.onStateStatusChange}
                  onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
                />
              </div>
            ) : (
              <div className="position-rel">
                <DefaultComp
                  heading="There are no requisitions to display"
                  subheading="Get started by creating your first requisition!"
                  imageSrc={empty}
                />
                {this.state.permissions.editable && (
                  <div className="text-center margin-top-24">
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={() => this.setState({ flag: true })}
                    >
                      Create new
                    </Button>
                  </div>
                )}
              </div>
            )}
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={this.createNewMenuClose}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onEdit}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onDelete}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Delete </span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(index)),
);
